// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__m2eYd","header":"ClearentDisclaimer_header__3jVc2","inner":"ClearentDisclaimer_inner__3c36m"};